import React from "react"
import styles from "./styles.scss"
import CaseStudyCTA from "components/CaseStudyCTA"
import cx from "classnames"
import Reveal from "components/Reveal"
import { Link } from "react-router-dom"
import { detect } from "detect-browser"

const browser = detect()

class CaseStudySection extends React.Component {
  render() {
    let caseStudy = { ...this.props.caseStudy }
    if (caseStudy.quote) {
      delete caseStudy.quote
    }

    const { variant } = this.props

    return (
      <section
        className={cx(styles.container, {
          [styles.light]: variant === "light",
        })}
      >
        <Reveal className={styles.wrapper}>
          <div className={styles.ctaContainer}>
            <CaseStudyCTA caseStudy={caseStudy} variant={variant} />
          </div>
          <Link to={caseStudy.path} className={styles.imageContainer}>
            <img
              src={caseStudy.caseStudiesPageImage}
              alt={caseStudy.caseStudiesPageImageAltText}
              className={cx(styles.image, {
                [styles.ie]: browser.name === "ie",
              })}
            />
          </Link>
        </Reveal>
      </section>
    )
  }
}

export default CaseStudySection



// WEBPACK FOOTER //
// ./src/pages/CaseStudiesPage/CaseStudySection/index.jsx